import type { ExpenseView } from '@chukua/common';
import { formatMoney } from '../../../shared/policies/format-money';

export type DecisionMode = 'approve' | 'reject' | 'exception';

export const DECISION_LABELS: Record<DecisionMode, string> = { approve: 'Approve', reject: 'Reject', exception: 'Approve as exception' };

/**
 * Why a decision is not offered for this expense, or null when it is. The same two rules the server enforces (`expense-decision.policy.ts`):
 * spend with no receipt cannot simply be approved, and an exception is only for spend with none. The server stays the authority.
 */
export function decisionBlockedReason(mode: DecisionMode, expense: Pick<ExpenseView, 'receipts'>): string | null {
  const hasReceipt = expense.receipts.length > 0;
  if (mode === 'approve' && !hasReceipt) return 'No receipt: reject it, or approve it as an exception';
  if (mode === 'exception' && hasReceipt) return 'It has a receipt, so approve it instead';
  return null;
}

const PAST_TENSE: Record<DecisionMode, string> = { approve: 'approved', reject: 'rejected', exception: 'approved as an exception' };

/** "Expense approved: Fuel KES 4,500 for Wanjiru", said after the server confirms. */
export function decisionToast(mode: DecisionMode, expense: Pick<ExpenseView, 'category' | 'amount' | 'driverName'>): string {
  return `Expense ${PAST_TENSE[mode]}: ${expense.category.name} ${formatMoney(expense.amount)} for ${expense.driverName}`;
}
